const jumpToUrl = url => {
    window.location.replace(url);
};

export {jumpToUrl};